export default {_name:'field.text.multiline',module:'Field',view:'Element/Field/Text',options:{multiline:true,minRows:3}}